import { MDBCol } from 'mdb-react-ui-kit'
import React from 'react';
import { motion } from "framer-motion"


const ImageBlock = ({myImage}) => {
  return (
    <MDBCol className="col-sm-12 col-md-6 text-center d-flex justify-content-center align-items-center align-self-stretch mb-0 px-0" style={{ overflow: 'hidden' }}>
            <motion.div className="section-image section-full-frame" initial={{ scale: 0.5, opacity: 0 }} whileInView={{ scale: [1.0, 1.2, 1.0], opacity: 1 }}  transition={{ delay: 0.15 }} >
                <img className="section-image section-full-frame" src={myImage} alt="" ></img>
            </motion.div>
    </MDBCol>
  )
}

export default ImageBlock